import ReturnRequests from "layouts/returnRequest/List";
import Details from 'layouts/returnRequest/Details.js';
import ProtectedRoute from "./ProtectedRoute";

const ReturnRequestRoutes = [
  {
    route: "/returnRequests/list/:pageNo",
    key: "return-request",
    component: <ProtectedRoute check="logout"><ReturnRequests /></ProtectedRoute>
  },
  {
    route: "/returnRequests/details/:returnID",
    key: "return-request-details",
    component: <ProtectedRoute check="logout"><Details /></ProtectedRoute>
  },    

  ];

export default ReturnRequestRoutes;